import { getSearchApiBaseUrl } from '../../api/platform-client.js';
export async function buildResultPreviewRequest(state, options) {
    const { search, accessToken, organizationId } = state.configuration;
    const q = state.query?.q || '';
    return {
        url: search.apiBaseUrl ??
            getSearchApiBaseUrl(state.configuration.organizationId, state.configuration.environment),
        accessToken,
        organizationId,
        enableNavigation: false,
        q,
        ...options,
        requestedOutputSize: options.requestedOutputSize || 0,
        ...(search.authenticationProviders.length && {
            authentication: search.authenticationProviders.join(','),
        }),
    };
}
